import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CapitalizePipe } from '../core/pipes/capitalize.pipe';
import { NoteTimeDatePipe } from '../core/pipes/note-time-date.pipe';
import { AbbreviateNumberPipe } from '../core/pipes/abbreviate-number.pipe';
import { FullMonthYearPipe } from '../core/pipes/full-month-year.pipe';
import { GaugeChartComponent } from './components/gauge-chart/gauge-chart.component';
import { BarChartComponent } from './components/bar-chart/bar-chart.component';
import { WarningBannerComponent } from './components/warning-banner/warning-banner.component';
import { DownloadSpreadsheetButtonComponent } from '../features/service-insights/components/download-spreadsheet-button/download-spreadsheet-button.component';
import { AdvanceFiltersComponent } from './components/advanced-filters/advanced-filters.component';
import { SelectBoxComponent } from './components/advanced-filters/select-box/select-box.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { FormsModule } from '@angular/forms';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { MatInputModule } from '@angular/material/input';
import { ParseNumberPipe } from '../core/pipes/parse-number.pipe';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { CurrencySymbolPipe } from '../core/pipes/currency-symbol.pipe';
import { PhotoSelectionBarComponent } from './components/photo-selection-bar/photo-selection-bar.component';
import { DownloadButtonComponent } from './components/download-button/download-button.component';
import { SignedNumberPipe } from '../core/pipes/signed-number.pipe';
import { MonthYearRangePipe } from '../core/pipes/month-year-range.pipe';
import { AdvancedFiltersSelectionComponent } from './components/advanced-filters-selection/advanced-filters-selection.component';

@NgModule({
  imports: [
    FormsModule,
    MatIconModule,
    MatInputModule,
    MatChipsModule,
    ScrollingModule,
    CommonModule,
  ],
  declarations: [
    CapitalizePipe,
    AbbreviateNumberPipe,
    FullMonthYearPipe,
    NoteTimeDatePipe,
    GaugeChartComponent,
    BarChartComponent,
    WarningBannerComponent,
    DownloadSpreadsheetButtonComponent,
    AdvanceFiltersComponent,
    AdvancedFiltersSelectionComponent,
    SelectBoxComponent,
    ParseNumberPipe,
    ClickOutsideDirective,
    CurrencySymbolPipe,
    PhotoSelectionBarComponent,
    DownloadButtonComponent,
    SignedNumberPipe,
    MonthYearRangePipe
  ],
  exports: [
    CapitalizePipe,
    AbbreviateNumberPipe,
    FullMonthYearPipe,
    NoteTimeDatePipe,
    GaugeChartComponent,
    BarChartComponent,
    WarningBannerComponent,
    DownloadSpreadsheetButtonComponent,
    AdvanceFiltersComponent,
    AdvancedFiltersSelectionComponent,
    SelectBoxComponent,
    ParseNumberPipe,
    ClickOutsideDirective,
    CurrencySymbolPipe,
    PhotoSelectionBarComponent,
    DownloadButtonComponent,
    SignedNumberPipe,
    MonthYearRangePipe
  ],
})
export class SharedModule {}
